import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { WritingAction } from '../../types/sounds-writing.types.ts';

import { SoundsWritingState } from './sounds-writing.slice.types.ts';

const initialState: SoundsWritingState = {
  userWritingPath: [],
  isDrawingEnabled: false,
};

export const soundsWritingSlice = createSlice({
  name: 'soundsWriting',
  initialState,
  reducers: {
    resetUserWritingPath: (state) => {
      state.userWritingPath = [];
    },
    pushWritingAction: (state, action: PayloadAction<WritingAction>) => {
      state.userWritingPath.push(action.payload);
    },
    enableDrawing: (state) => {
      state.isDrawingEnabled = true;
    },
    disableDrawing: (state) => {
      state.isDrawingEnabled = false;
    },
  },
});

export const { resetUserWritingPath, pushWritingAction, enableDrawing, disableDrawing } = soundsWritingSlice.actions;

export const SoundsWritingSlice = soundsWritingSlice.reducer;
